import { render, staticRenderFns } from "./cus-recycle-scroller.vue?vue&type=template&id=134cd95f&scoped=true"
import script from "./cus-recycle-scroller.vue?vue&type=script&lang=js"
export * from "./cus-recycle-scroller.vue?vue&type=script&lang=js"
import style0 from "./cus-recycle-scroller.vue?vue&type=style&index=0&id=134cd95f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134cd95f",
  null
  
)

export default component.exports